module.exports = __webpack_public_path__ + "static/media/darth-vader.4b898287.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/darth-vader.jpg
// module id = 35
// module chunks = 0